/* eslint-disable max-len */
import { ReactElement } from 'react';
import GradesAndPromotions_StudentDetailsPanel from './GradesAndPromotions_StudentDetailsPanel';
import GradesAndPromotions_UpdateGradesPanel from './GradesAndPromotions_UpdateGradesPanel';

const GradesAndPromotions_Layout = (): ReactElement => {
  return (
    <>
      <GradesAndPromotions_StudentDetailsPanel />
      <GradesAndPromotions_UpdateGradesPanel />
    </>
  );
};

export default GradesAndPromotions_Layout;
